// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"4c172ea4","440":"ffa0409c","453":"fe8afbbd","733":"ab52392b","744":"f880a82f"}[chunkId] + ".chunk.js";
};